var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 28.3332H22.4998C26.6665 28.3332 28.3332 26.6665 28.3332 22.4998V17.4998C28.3332 13.3332 26.6665 11.6665 22.4998 11.6665H17.4998C13.3332 11.6665 11.6665 13.3332 11.6665 17.4998V22.4998C11.6665 26.6665 13.3332 28.3332 17.4998 28.3332Z",
    stroke: "#535862",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3918 16.2581C20.9752 16.1331 20.5168 16.0498 20.0002 16.0498C17.7002 16.0498 15.8335 17.9165 15.8335 20.2165C15.8335 22.5165 17.7002 24.3831 20.0002 24.3831C22.3002 24.3831 24.1668 22.5165 24.1668 20.2165C24.1668 19.3581 23.9085 18.5665 23.4668 17.8998",
    stroke: "#535862",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9834 16.3749L20.6001 14.7832",
    stroke: "#535862",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9834 16.375L20.3667 17.5583",
    stroke: "#535862",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.fc785865bc4cf3716d64f8d07e11c118.svg";
export { ForwardRef as ReactComponent };